export default __webpack_public_path__ + "static/media/visa.0409d0eb.svg";